/** Optional visual household size; older saved pins default to one person. */
export function householdSize(value: unknown): number {
  return typeof value === 'number' && Number.isFinite(value)
    ? Math.max(1, Math.min(99, Math.floor(value)))
    : 1;
}
